import { createSelector } from "reselect";
import _ from "lodash";
const createSelectors = (parentReducer) => {
    return new (class {
        getUsers = (store) => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["JobPackProfileRelatedReportsWidget_reducer"];
            return reducer.users;
        };
        selectJobpack = (store) => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["JobPackProfileRelatedReportsWidget_reducer"];
            return reducer.jobpack;
        };
        selectRecieptsData = (store) => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["JobPackProfileRelatedReportsWidget_reducer"];

            return reducer.receieptsData;
        };

        selectReportTitles = (store) => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["JobPackProfileRelatedReportsWidget_reducer"];
            return reducer.reportTitles;
        };
        selectReports = createSelector(
            [this.selectJobpack],
            (jobpack = false) => {
                if (jobpack) {
                    let reports = _.get(jobpack, "reports") || false;
                    if (reports) {
                        let reportInfo = _.flatten(
                            Object.keys(reports).map((e) => {
                                let report_type = e;
                                return Object.keys(reports[e]).map((f) => {
                                    let timestamp = f;
                                    let user_name = _.get(
                                        reports[e][f],
                                        "user_name"
                                    );
                                    return {
                                        report_type,
                                        timestamp,
                                        user_name,
                                    };
                                });
                            })
                        );
                        return _.orderBy(reportInfo, "timestamp", ["desc"]);
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            }
        );
        selectRegisteredUsers = createSelector([this.getUsers], (users) => {
            if (
                users === false ||
                typeof users === "undefined" ||
                users === null
            ) {
                return [];
            }

            let regUsers = Object.keys(users).map((e) => {
                return {
                    name: `${_.get(users[e], "profile.first_name")} ${_.get(
                        users[e],
                        "profile.last_name"
                    )}`,
                    uid: _.get(users[e], "profile.uid"),
                    deleted: _.get(users[e], "profile.deleted"),
                };
            });
            if (regUsers) {
                return regUsers.sort((a, b) => a.name.localeCompare(b.name));
            }
            return regUsers.filter((e) => {
                if (e.deleted !== true) {
                    return true;
                } else {
                    return false;
                }
            });
        });
    })();
};
export default createSelectors;
